<template>
  <FunBookV2TermsPage />
</template>

<script>
import FunBookV2TermsPage from '@/components/FunBookV2TermsPage.vue'

export default defineComponent({
  name: 'TOSPage',
  components: {
    FunBookV2TermsPage,
  },
})
</script>
